// extracted by mini-css-extract-plugin
export var cardIcon = "_7i-5";
export var cardIconUnframed = "_7i-9";
export var checkboxCard = "_7i-0";
export var checkboxCardSelected = "_7i-4";
export var disabled = "_7i-2";
export var interactive = "_7i-1";
export var outerBorder = "_7i-3";
export var spacerMedium = "_7i-8";
export var spacerSmall = "_7i-7";
export var spacerXsmall = "_7i-6";